import { render, staticRenderFns } from "./VoteButton.vue?vue&type=template&id=2c7b2985&"
import script from "./VoteButton.vue?vue&type=script&lang=ts&"
export * from "./VoteButton.vue?vue&type=script&lang=ts&"
import style0 from "./VoteButton.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports